import { useEffect } from "react";
import { TOPIC_CATEGORIES } from "../../constants/community";

function timeAgo(dateStr) {
  const now = new Date();
  const date = new Date(dateStr);
  const diff = Math.floor((now - date) / 1000);
  if (diff < 60) return "vừa xong";
  if (diff < 3600) return `${Math.floor(diff / 60)} phút trước`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} giờ trước`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)} ngày trước`;
  return date.toLocaleDateString("vi-VN");
}

function TopicSkeleton() {
  return (
    <div className="topic-card skeleton-card">
      <div className="topic-card-header">
        <div className="topic-author">
          <div className="skeleton-circle" />
          <div className="skeleton-row" style={{ width: "80px" }} />
          <div className="skeleton-row" style={{ width: "50px" }} />
        </div>
      </div>
      <div className="skeleton-row" style={{ width: "70%", height: "16px" }} />
      <div className="skeleton-row" style={{ width: "90%", marginTop: "6px" }} />
      <div className="topic-card-footer" style={{ marginTop: "10px" }}>
        <div className="skeleton-row" style={{ width: "60px" }} />
        <div className="skeleton-row" style={{ width: "30px" }} />
      </div>
    </div>
  );
}

export default function TopicList({
  topics, loading, hasMore, categoryFilter,
  onChangeCategory, onLoadMore, onSelectTopic, onShowComposer, loadTopics,
}) {
  useEffect(() => {
    if (topics.length === 0 && !loading) {
      loadTopics(categoryFilter, 1);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="community-topics">
      {/* Category filter */}
      <div className="topic-filters">
        <button
          className={`topic-filter-btn ${!categoryFilter ? "active" : ""}`}
          onClick={() => onChangeCategory(null)}
        >
          Tất cả
        </button>
        {TOPIC_CATEGORIES.map(cat => (
          <button
            key={cat.id}
            className={`topic-filter-btn ${categoryFilter === cat.id ? "active" : ""}`}
            onClick={() => onChangeCategory(cat.id)}
          >
            {cat.emoji} {cat.label}
          </button>
        ))}
      </div>

      {/* Create button */}
      <button className="topic-create-btn" onClick={onShowComposer}>
        + Tạo chủ đề mới
      </button>

      {/* Topics list */}
      {loading && topics.length === 0 ? (
        <div className="topic-skeleton-list">
          {[1, 2, 3, 4].map(i => <TopicSkeleton key={i} />)}
        </div>
      ) : topics.length === 0 ? (
        <div className="community-empty">
          <div style={{ fontSize: "28px", marginBottom: "8px" }}>💬</div>
          <div>Chưa có chủ đề nào. Hãy tạo chủ đề đầu tiên!</div>
        </div>
      ) : (
        <>
          {topics.map(topic => {
            const cat = TOPIC_CATEGORIES.find(c => c.id === topic.category);
            return (
              <div
                key={topic.id}
                className="topic-card"
                onClick={() => onSelectTopic(topic.id)}
              >
                <div className="topic-card-header">
                  <div className="topic-author">
                    {topic.profiles?.avatar_url ? (
                      <img src={topic.profiles.avatar_url} alt="" className="topic-avatar" />
                    ) : (
                      <div className="topic-avatar-placeholder">
                        {(topic.profiles?.display_name || "?")[0]}
                      </div>
                    )}
                    <span className="topic-author-name">
                      {topic.profiles?.display_name || "Ẩn danh"}
                    </span>
                    <span className="topic-time">{timeAgo(topic.created_at)}</span>
                  </div>
                  {topic.is_pinned && <span className="topic-pinned">📌</span>}
                </div>
                <div className="topic-card-title">{topic.title}</div>
                {topic.body && (
                  <div className="topic-card-body">
                    {topic.body.length > 120 ? topic.body.slice(0, 120) + "..." : topic.body}
                  </div>
                )}
                <div className="topic-card-footer">
                  {cat && (
                    <span className="topic-category-badge">
                      {cat.emoji} {cat.label}
                    </span>
                  )}
                  <span className="topic-reply-count">
                    💬 {topic.reply_count || 0}
                  </span>
                </div>
              </div>
            );
          })}

          {hasMore && (
            <button
              className="topic-load-more"
              onClick={onLoadMore}
              disabled={loading}
            >
              {loading ? "Đang tải..." : "Xem thêm"}
            </button>
          )}
        </>
      )}
    </div>
  );
}
